<template>
    <search-group  :span="24" :btnOffset="20" :multipleLines="true"   @search="findData" @clear="clearValue" >
        <Row class="mb16" :gutter="16">
            <Col span="4">
              <Select v-model="searchData.projectFid" placeholder="请选择项目">
                <Option value=''>请选择</Option>
                <Option v-for="item in projectList" :value="item.value" :key="item.value">{{item.text}}</Option>
              </Select>
            </Col>
            <Col span="4">
              <Select v-model="searchData.contractState" placeholder="合同状态" >
                <Option value=''>请选择</Option>
                <Option v-for="item in contractState" :value="item.value" :key="item.value">{{item.text}}</Option>
              </Select>
            </Col>
            <Col span="4">
              <Select v-model="searchData.rentType" placeholder="租约类型">
                <Option value=''>请选择</Option>
                <Option v-for="item in leaseTimeeEnums" :value="item.value" :key="item.value">{{item.text}}</Option>
              </Select>
            </Col>
            <Col span="4">
              <Select v-model="searchData.contractType" placeholder="签约类型">
                <Option value=''>请选择</Option>
                <Option v-for="item in contractSignType" :value="item.value" :key="item.value">{{item.text}}</Option>
              </Select>
            </Col>
            <Col span="4">
              <Select v-model="searchData.isRenew" placeholder="续约状态">
                <Option value=''>请选择</Option>
                <Option  v-for="item in renewStatusList" :value="item.value" :key="item.value">{{item.text}}</Option>
              </Select>
            </Col>
            <Col span="4">
              <Select v-model="searchData.source" placeholder="签约方式" >
                <Option value=''>请选择</Option>
                <Option v-for="item in contractSource" :value="item.value" :key="item.value">{{item.text}}</Option>
              </Select>
            </Col>
        </Row>
        <Row :gutter="16">
          <Col span="4">
            <Select v-model="searchData.deliveryState" placeholder="物业交割状态">
              <Option value=''>请选择</Option>
              <Option v-for="item in contractDelivery" :value="item.value" :key="item.value">{{item.text}}</Option>
            </Select>
          </Col>
          <Col span="7">
            <DatePicker v-model="signDay" split-panels type="daterange" format="yyyy-MM-dd" @on-change="changeSignDay" placeholder="签约日"></DatePicker>
          </Col>
          <Col span="7">
            <DatePicker v-model="dueDay" split-panels type="daterange" format="yyyy-MM-dd" @on-change="changeDueDay" placeholder="到期日"></DatePicker>
          </Col>
          <Col span="6">
            <Input type="text" v-model="searchData.stockNumber" placeholder="签约客户、签约手机号、房间号" @keyup.enter.native="findData"></Input>
          </Col>
        </Row>
    </search-group>
</template>

<script type="text/ecmascript-6">

import SearchGroup from 'components/SearchGroup/index';
import {getProjects } from 'api/common'
import { getConditions} from 'api/auditContract'
export default {
  created(){
    this.initCondition()
  },
  components: {
    SearchGroup
  },
  data () {
    return {
      searchData:{
        projectFid:'',
        contractState:'',
        rentType:'',
        contractType:'',
        isRenew:'',
        source:'',
        deliveryState:'',
        signEndDate:'',
        signStartDate:'',
        expireStartDate:'',
        expireEndDate:'',
        stockNumber:'',
        limit: 10,
        page: 1
      },
      signDay:[],
      dueDay:[],
      projectList:[],
      contractState:[],
      contractSignType:[],
      contractSignType:[],
      leaseTimeeEnums:[],
      //contractSource:[],
      renewStatusList:[{
        value:0,
        text:'未续约'

      },{
        value:1,
        text:'已续约'
      }],
      contractSource:[],
      contractDelivery:[]
    }
  },
  methods: {
    changeSignDay(val){
      this.searchData.signStartDate = val[0]
      this.searchData.signEndDate = val[1]
    },
    changeDueDay(val){
      this.searchData.expireStartDate = val[0]
      this.searchData.expireEndDate = val[1]
    },
    initCondition(){
      getProjects().then( res => {
        this.projectList = res.data
      })
      getConditions().then( res => {
        this.leaseTimeeEnums = res.data.leaseTime
        this.contractState = res.data.contractState
        this.contractSignType = res.data.contractSignType
        this.contractDelivery = res.data.contractDelivery
        this.contractSource = res.data.contractSource
      })
    },
    findData() {
      this.$emit('findData',this.searchData)
    },
    clearValue() {
      this.searchData.page = 1
      this.signDay=[]
      this.dueDay = []
      for (let key in this.searchData){
        if(key ==='page' || key === 'limit') continue
        this.searchData[key] = ''
      }
    }
  }
}
</script>
<style scoped>
.dash {
    text-align: center;
  }
  .dash span {
    display: inline-block;
    width: 60%;
    height: 2px;
    background: #dddee1;
    vertical-align: middle;
  }

.ivu-date-picker {
  width: 100%;
}
</style>

